/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser'
import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'
import { environment } from '@environments/environment'
import * as Sentry from '@sentry/angular'

Sentry.init({
  dsn: environment.sentryDsn,
  integrations: [],
  tracePropagationTargets: ['localhost', 'app-dev.gfcard.dk', 'app.gfcard.dk'],
})

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err))
